/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SmartForm } from 'components';
import { saveSetting, getSetting } from 'rdx/config';
import { valueToInteger } from 'utils';

import startEndDaySchema from './startEndDaySchema';
import './startEndDay.scss';

const DAY = {
  BY_DRAWER: 'BY_DRAWER',
  BY_REGISTER: 'BY_REGISTER',
};

function SaleDocuments() {
  const settingsFormRef = React.useRef(null);
  const dispatch = useDispatch();
  const [configState, setConfigState] = useState({});

  const touchpos_eod_allowed_difference = useSelector(
    getSetting('touchpos_eod_allowed_difference'),
  );
  const touchpos_eod_disable_show_expected = useSelector(
    getSetting('touchpos_eod_disable_show_expected'),
  );
  const touchpos_eod_disable_count_all_payment_types = useSelector(
    getSetting('touchpos_eod_disable_count_all_payment_types'),
  );
  const touchpos_eod_reason_required = useSelector(
    getSetting('touchpos_eod_reason_required'),
  );
  const touchpos_get_short_report = useSelector(
    getSetting('touchpos_get_short_report'),
  );
  const touchpos_get_report_only_last_shift = useSelector(
    getSetting('touchpos_get_report_only_last_shift'),
  );
  const touchpos_disable_deposit_on_eod = useSelector(
    getSetting('touchpos_disable_deposit_on_eod'),
  );
  const cash_inout_open_drawer = useSelector(
    getSetting('cash_inout_open_drawer'),
  );
  const touchpos_remove_pending_sales_before_close_day = useSelector(
    getSetting('touchpos_remove_pending_sales_before_close_day'),
  );
  const touchpos_eod_notes_required = useSelector(
    getSetting('touchpos_eod_notes_required'),
  );

  const pos_shifts_counted =
    useSelector(getSetting('pos_shifts_counted')) === DAY.BY_DRAWER;

  useEffect(() => {
    setConfigState({
      touchpos_eod_allowed_difference,
      touchpos_eod_disable_show_expected,
      touchpos_eod_disable_count_all_payment_types,
      touchpos_eod_reason_required,
      touchpos_get_short_report,
      touchpos_get_report_only_last_shift,
      touchpos_disable_deposit_on_eod,
      cash_inout_open_drawer,
      touchpos_remove_pending_sales_before_close_day,
      touchpos_eod_notes_required,
      pos_shifts_counted,
    });
  }, [
    touchpos_eod_allowed_difference,
    touchpos_eod_disable_show_expected,
    touchpos_eod_disable_count_all_payment_types,
    touchpos_eod_reason_required,
    touchpos_get_short_report,
    touchpos_get_report_only_last_shift,
    touchpos_disable_deposit_on_eod,
    cash_inout_open_drawer,
    touchpos_remove_pending_sales_before_close_day,
    touchpos_eod_notes_required,
    pos_shifts_counted,
  ]);

  const submitSetting = () => {
    const { values: currentValues } = settingsFormRef.current;

    Object.entries(currentValues).forEach(([key, value]) => {
      const payload = {};

      payload.parameterName = key;
      payload.parameterValue =
        typeof value === 'boolean' ? valueToInteger(value) : value;
      if (key === 'pos_shifts_counted') {
        payload.parameterValue = payload.parameterValue
          ? DAY.BY_DRAWER
          : DAY.BY_REGISTER;
      }

      if (payload.parameterValue !== configState[key])
        dispatch(saveSetting(payload));
    });
  };

  return (
    <SmartForm
      grid
      ref={settingsFormRef}
      state={configState}
      fields={startEndDaySchema}
      autosave
      handleSubmit={submitSetting}
      className="start-end-day-form"
    />
  );
}

export default SaleDocuments;
